query ConfigEdit($id: ID!) {
  config(id: $id) {
    id
    key
    value
  }
}
